import Initials from "./initials.js";
import { getDataFromScript, hide, show } from "./utils/helpers.js";
import Template from "./utils/template.js";

export default class Cart {

  constructor() {
    const me = this;
    this.reviewForm = document.getElementById('review-order-form');

    if (this.reviewForm) {
      this.formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });

      this.isStoreFront = this.reviewForm.dataset.isStoreFront === '1';
      this.orgNameInCartOrDefault = this.reviewForm.dataset.orgNameInCartOrDefault;
      this.lastOrgSavedInSessionStorage = sessionStorage.getItem('current_org');
      this.completePurchaseBtn = document.getElementById('catalog_install');
      this.billingOrgPicker = document.getElementById('catalog_install_organization');

      // Coupon Vars
      this.couponPath = this.reviewForm.dataset.couponPath;
      this.promoCodeInput = document.getElementById('promo_code');

     // Order amount Vars
      this.addonsQuantityInputs = document.querySelectorAll(".qty-addons-input");
      const { total, addons = [], itemPrice = 0, planSetupFee = 0 } = getDataFromScript('order-data');
      this.totalOrder = total;
      this.addons = addons;
      this.itemPrice = itemPrice;
      this.planSetupFee = planSetupFee;

      this.initBillingOrgPicker();

      if (this.billingOrgPicker) {
        this.updateView(this.billingOrgPicker);

        // Update view according with the org selected.
        $(this.billingOrgPicker).chosen().change((e) => {
          me.updateView(e.target);
          me.completePurchaseBtn.disabled = false;
          hide(document.querySelector('#errorNoBillling'));
        });
      }

      this.disableSubmitBtn();

      // Apply Coupon
      this.applyCouponBtn = document.querySelector('.apply_coupon');
      if (this.applyCouponBtn) {
        this.applyCouponBtn.addEventListener('click', this.applyCoupon.bind(this));
      }

      // Reset promo code input
      this.removeCodeBtn = document.querySelector('.remove_promo_code_btn');
      if (this.removeCodeBtn) {
        this.removeCodeBtn.addEventListener('click', this.resetPromoCode.bind(this));
      }

      // Recalculate when updating addons qty
      if (this.addonsQuantityInputs.length) {
        this.addonsQuantityInputs.forEach((input) => {
          this.totalOrder = this.recalculateTotal(input);
          this.renderOrderAmount(this.totalOrder);
          input.addEventListener('change', () => {
            me.totalOrder = me.recalculateTotal(input);
            me.renderOrderAmount(me.totalOrder);
          })
        });
      } else {
        this.renderOrderAmount(this.totalOrder);
      }
    }
  }


  initBillingOrgPicker() {
    if(this.billingOrgPicker) {
      if (this.isStoreFront) {
        document.querySelector(`#${ this.billingOrgPicker.id } [value="${ this.lastOrgSavedInSessionStorage ? this.lastOrgSavedInSessionStorage : this.orgNameInCartOrDefault }"]`).selected = true;
      } else {
        document.querySelector(`#${ this.billingOrgPicker.id } [value="${ this.orgNameInCartOrDefault }"]`).selected = true;
      }
    }
  }

  getOrgTitleFromPicker = (picker) => {
    const selectedOption = this.getSelectedOption(picker),
      hasImage = selectedOption.dataset.imgUrl || null;
    let orgTitle = selectedOption.innerText.trim();

    // The orgTitle html brings the first letter that is from the default avatar
    // and this is to remove it. And it only happens on desktop since on mobile
    // the plugin (chosen select) doesn't work
    if (window.matchMedia('(min-width: 991px)').matches && !hasImage) {
      orgTitle = orgTitle.substring(1);
    }

    return orgTitle
  }

  updateView = (picker) => {
    const { dataset: { orgType, imgUrl } } = this.getSelectedOption(picker);
    const orgDefaultAvatar = document.querySelector('#org_default_avatar');
    const orgImg = document.querySelector('#org_img');

    document.querySelector('#org_type').innerHTML = (orgType === 'developer') ? 'Personal Account' : 'Business Account';
    document.querySelector('#org_name').innerHTML = this.getOrgTitleFromPicker(picker);

    if (imgUrl) {
      orgImg.style.backgroundImage = "url(" + imgUrl  + ")";
      show(orgImg);
      hide(orgDefaultAvatar);
      orgDefaultAvatar.classList.remove('d-flex');
    } else {
      orgDefaultAvatar.innerHTML= picker.value.charAt(0).toUpperCase();
      orgDefaultAvatar.style.backgroundColor = new Initials().initialsToColor(picker.value);
      orgDefaultAvatar.classList.add('d-flex');
      show(orgDefaultAvatar);
      hide(orgImg);
    }
  }

  getSelectedOption = (picker) => picker.options[picker.options.selectedIndex];

  /**
   * Disable `Complete Purchase` button when submitting
   */
  disableSubmitBtn() {
    const me = this;
    this.reviewForm.addEventListener('submit', () => this.completePurchaseBtn.disabled = true)
  }

  /**
  * Promo code Handling
  */
  saveCoupon = (newCoupon) => {
    sessionStorage.setItem('coupon', JSON.stringify(newCoupon));
  }

  getCoupon = () => {
    let coupon = sessionStorage.getItem('coupon');
    if (coupon) {
      coupon = JSON.parse(coupon);
      this.renderPromoCodeInfo(coupon.discount, coupon.code);

      return coupon;
    }

    return null
  }

  renderPromoCodeInfo = (discount, code) => {
    document.querySelector('#promo_code_applied').innerText = code;
    document.querySelector('#promo_code_discount').innerText = `-$${ discount.toFixed(2) }`;
    show('#promo_code_info');
    this.promoCodeInput.value = code;
    this.promoCodeInput.setAttribute('readonly', true);
    this.applyCouponBtn.disabled = true;
  }

  resetPromoCode(e) {
    this.promoCodeInput.value = '';
    this.promoCodeInput.removeAttribute('readonly');
    this.applyCouponBtn.disabled = false;
    sessionStorage.removeItem('coupon');
    hide('#promo_code_info');
    this.renderOrderAmount(this.totalOrder);
  }

  calculateCouponDiscount = ({ percent, price }) => {
    let discount = 0;
    if (percent) {
      discount = (percent / 100) * (dueToday || totalOrder);
    } else {
      discount = price.amount;
    }
    return discount;
  }

  applyCoupon() {
      if (this.promoCodeInput.value) {
        this.applyCouponBtn.disabled = true;
        this.completePurchaseBtn.disabled = true;
        this.promoCodeInput.setAttribute('readonly', true);
        hide(promoCodeErrorLabel);

        const urlParams = {
          _promo_code_: encodeURIComponent(this.promoCodeInput.value),
          _org_name_: encodeURIComponent(this.billingOrgPicker ? this.billingOrgPicker.value : this.orgNameInCartOrDefault),
        }

        const getCouponPath = this.couponPath.replace(/_promo_code_|_org_name_/gi, (matched) => urlParams[matched]);

        $.ajax({
          url: getCouponPath,
          type: 'post',
          dataType: 'json',
          success: function(response) {
            const coupon = JSON.parse(response.coupon);
            if (coupon) {
              const discount = this.calculateCouponDiscount(coupon);
              this.saveCoupon({ ...coupon, discount });
              this.renderPromoCodeInfo(discount, coupon.code);
              this.renderOrderAmount(this.totalOrder);
            } else {
              this.showErrorForPromoCode('Promo code has expired, has already been redeemed, or is invalid');
            }
            this.completePurchaseBtn.disabled = false;
          }
        });
      } else {
        this.showErrorForPromoCode();
      }
  }

  showErrorForPromoCode = (errorText = 'Please enter a promo code.') => {
    const promoCodeErrorLabel = document.querySelector('.promo_code_error');
    promoCodeErrorLabel.innerText = errorText;
    this.applyCouponBtn.disabled = false;
    this.promoCodeInput.removeAttribute('readonly');
    show(promoCodeErrorLabel);
  }

  updateAddOn = (input) => {
    const { dataset: { addonid }, value: inputValue } = input;
    this.addons[addonid].qty = inputValue;
    return this.addons;
  }

  renderAddonsList = (addons) => {
    const addonsRow = document.getElementById('addons_row');
    while (addonsRow.firstChild) {
      addonsRow.removeChild(addonsRow.firstChild);
    }

    const template = `
    <div class="d-flex align-items-center justify-content-between h-xs-50p">
      <div>
        <h3 class="h6 mb-0 fw-400"><%= o.title %> x<%= o.value %></h3>
          <p class="small"><%= o.period %></p>
      </div>
      <h3 class="h6 mb-0 fw-400"><%= o.total %></h3>
    </div>
    `;

    const list = [];
    for (const item of this.addonsQuantityInputs) {
      if ( item.value < 1 ) {
        continue;
      }

      const currentBillingPeriodElem = document.querySelector('#current_billing_period');

      const addon = this.addons[item.dataset.addonid];
      const total = this.formatter.format(addon.pricePerUnit * addon.qty);
      const period = currentBillingPeriodElem.innerHTML;

      const listElem = new Template(
        template,
        {
          period,
          total,
          value: item.value,
          title: item.dataset.addonTitle,
        }
      );

      list.push(listElem.build());
    }

    const previousElem = addonsRow.previousElementSibling
    if (list.length) {
      previousElem.classList.add('border-bottom');
    } else {
      previousElem.classList.remove('border-bottom');
    }

    addonsRow.innerHTML = list.join('');
  }

  recalculateTotal = (input) => {
    const addonsUpdated = this.updateAddOn(input);
    let addonsPrices = [];
    for (const addonId in addonsUpdated) {
      if (addonsUpdated.hasOwnProperty(addonId)) {
        const addon = addonsUpdated[addonId];
        addonsPrices.push(addon.pricePerUnit * addon.qty);
      }
    }

    this.renderAddonsList(addonsUpdated);

    return addonsPrices.reduce((a, b) => a + b) + this.itemPrice + this.planSetupFee;
  }

  renderOrderAmount = (total) => {
    const dueTodayAmountElem = document.querySelector('#due_today_amount #price');
    dueTodayAmountElem.innerHTML = this.formatter.format(total);

    const coupon = this.getCoupon();
    if (coupon) {
      const discount = this.calculateCouponDiscount(coupon)
      this.renderPromoCodeInfo(discount, coupon.code);
      let dueTodayTotal = total - discount;
      if ( dueTodayTotal < 0 ) dueTodayTotal = 0; // Prevent render negative numbers
      dueTodayAmountElem.innerHTML = this.formatter.format(dueTodayTotal);
    }
  }
}
